import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssetlinksService {
  private _baseUrl = '/assets/'
  private _favicon='favicon.png'
  private _noResults='empty.svg'
  private _store = 'store.svg'
  private _voucherCongrats='voucher_congrats.svg'
  private _rewardCongrats='reward_congrats.svg'
  private _voucherReward='rewardVoucher.png'
  private _voucherRedeemedStamp='voucher_redeemed_stamp.svg'
  private _couponRedeemedStamp='coupon_redeemed_stamp.svg'
  private _stampHolder='coin_missing.svg'
  private _stamp='coin_stamped.svg'
  private _openLogoAnimationWhite = "open_animation_css_white.svg"
  private _openLogoAnimationGreen = "open_animation_css_green.svg"
  private _loadingImgAnimation = "loading.svg"
  
  private _underConstruction="under_construction.svg"
  private _backgroundImage ="stacked-waves-haikei.svg"
  private _yumpin_selected="6.png"
  private _yumpin_unselected="5.png"
  
  private _shop ="stacked-shop-haikei.svg"
  private _spinnerGif = "spinnerGif2.gif"
  private _confettiGif = "confetti.gif"
  private _fireWorksWav = "explosions.wav"
  private _story_small = "story_small.png"
  private _no_image = "errorimg_ink.png"
  private _loyalty_programme_small = 'loyalty_programme_small.png'
  private _card_loading = "card_loading.gif"
  private _avatar_loading = "avatar_loading.gif"
  private _person = "person.png"
  private _warning = "warning.png"
  private _addToWallet = 'add_to_wallet.svg'
  
  get addToWallet(){
    return `${this._baseUrl}${this._addToWallet}`
 }

 get store(){
  return `${this._baseUrl}${this._store}`
}
  get loyalty_programme_small(){
     return `${this._baseUrl}${this._loyalty_programme_small}`
  }
  get warning(){
    return `${this._baseUrl}${this._warning}`
  }
  get person(){
    return `${this._baseUrl}${this._person}`
  }
  get voucherReward(){
    return `${this._baseUrl}${this._voucherReward}` 
  }
  get noImage(){
    return `${this._baseUrl}${this._no_image}`
  }
   get cardLoading(){
    return `${this._baseUrl}${this._card_loading}`
  }
  get avatarLoading(){
    return `${this._baseUrl}${this._avatar_loading}`
  }
  get story_small(){
    return `${this._baseUrl}${this._story_small}`
  }
  private _story = "story.png"
  get story(){
    return `${this._baseUrl}${this._story}`
  }
  get yumpinSelected(){
    return `${this._baseUrl}${this._yumpin_selected}`
  }
  get yumpinUnSelected(){
    return `${this._baseUrl}${this._yumpin_unselected}`
  }
  get shop(){
    return `${this._baseUrl}${this._shop}`
  }
  get voucherRedeemedStamp(){
    return `${this._baseUrl}${this._voucherRedeemedStamp}`
  }
  get couponRedeemedStamp(){
    return `${this._baseUrl}${this._couponRedeemedStamp}`
  }
  get voucherCongrats(){
    return `${this._baseUrl}${this._voucherCongrats}`
  }
  get rewardCongrats(){
    return `${this._baseUrl}${this._rewardCongrats}`
  }
  get favicon(){
    return `${this._baseUrl}${this._favicon}`
  }
  get noResults(){
    return `${this._baseUrl}${this._noResults}`
  }
  get stampHolder(){
    return `${this._baseUrl}${this._stampHolder}`
  }
  get stamp(){
    return `${this._baseUrl}${this._stamp}`
  }


  get whiteOpenLogoAnimation(){
    return `${this._baseUrl}${this._openLogoAnimationWhite}`
  }
  get greenOpenLogoAnimation(){
    return `${this._baseUrl}${this._openLogoAnimationGreen}`
  }
  get loadingImgAnimation(){
    return `${this._baseUrl}${this._loadingImgAnimation}`
  }

  get underConstruction(){
    return `${this._baseUrl}${this._underConstruction}`
  }

  get backgroundImage(){
    return `${this._baseUrl}${this._backgroundImage}`
  }
  get spinnerGif(){
    return `${this._baseUrl}${this._spinnerGif}`
  }
  get confettiGif(){
    return `${this._baseUrl}${this._confettiGif}`
  }
  get fireWorksWav(){
    return `${this._baseUrl}${this._fireWorksWav}`
  }
  constructor() { }
}
